import type { QualityLevel } from '|>/core/index.h'

import { BaseMenuItem } from '|>/components/base.js'
import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { register } from '|>/shared/vjs'
import {
  autoQuality,
  getQualityItemPixels,
  isAutoQualityPixelsEnbled,
} from './helpers'

@register
export class QualityMenuItem extends BaseMenuItem {
  level: QualityLevel | undefined = undefined
  isAuto: boolean = false
  maxAutoQuality: Events.Media.MaxAutoQuality = undefined
  isSelectedQualityAllowed: Events.Player.IsSelectedQualityAllowed | undefined

  constructor(player, options) {
    super(player, options)
    this.level = options.level
    this.isAuto = Boolean(options.isAuto)
    this.isSelectedQualityAllowed = options.isSelectedQualityAllowed
    this.addClass(`vjs-quality-menu-item`)
    this.maxAutoQuality = options.maxAutoQuality

    if (!this.isQualityAllowed()) {
      this.addClass('vjs-quality-menu-item-disabled')
    } else {
      this.removeClass('vjs-quality-menu-item-disabled')
    }
  }

  private isQualityAllowed(manuallySelected: boolean = false): boolean {
    if (this.isAuto) {
      return true
    }

    if (!this.level) {
      return true
    }

    if (!this.isSelectedQualityAllowed) {
      return true
    }

    return this.isSelectedQualityAllowed({
      quality: getQualityItemPixels(this.level),
      ...(manuallySelected && { manuallySelected: true }),
    })
  }

  override handleClick(e) {
    e.stopPropagation()

    if (!this.isQualityAllowed(true)) {
      return
    }

    const qualityList = this.player_.qualityLevels()

    if (qualityList) {
      this.player_.trigger(Events.User.Intent, Intent.ChangeQuality)

      for (let i = 0; i < qualityList.length; ++i) {
        const level = qualityList[i]
        const pixels = getQualityItemPixels(level)

        level.enabled = this.isAuto
          ? isAutoQualityPixelsEnbled({
              pixels,
              maxAutoQuality: this.maxAutoQuality,
              isSelectedQualityAllowed: this.isSelectedQualityAllowed,
            })
          : level.id === this.level?.id
      }

      this.player_.trigger(
        Events.Media.QualityLevelSelected,
        this.isAuto ? autoQuality : this.level
      )
    }
  }
}
